import {Observable}  from 'rxjs';
import {filter, map} from 'rxjs/operators';

import UiEventType            from '../../../../Ui/Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../../Ui/Shared/Interfaces/IUiEventsStreamPayload';

const createTimelineScrubStream = (uiEvents$: Observable<IUiEventsStreamPayload>): Observable<number> =>
    uiEvents$
        .pipe(
            filter(({type}) => type === UiEventType.TIMELINE_SCRUB),
            map(({eventData}) => eventData.multiplier)
        );

export default createTimelineScrubStream;